
import footer from './footer.css' 
import saledFlying from '../assets/Salad-flying.png'   
import mixedFruits from '../assets/mixedFruits.png'  
import customerReview from '../assets/customerReview.png'
import {FaTwitter} from 'react-icons/fa'
import {FaTiktok} from 'react-icons/fa'
import {FaInstagram} from 'react-icons/fa'
import {FaCopyright} from 'react-icons/fa'



function Footer(){
    const dateBuilder = (d)=>{
        let months = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
        let days = ["Sunday","Monday","Tueday","Wednesday","Thursday","Friday","Saturday"]
      
      
      let today = days[d.getDay()];
      let c_day = d.getDate();
      let currMounth = months[d.getMonth()];
      let year = d.getFullYear();
      
      return ` ${year} `
      
      }
return (
    <>
    <footer>
    <div className='footer-container'>
    <div className='footer'>
    <div className='footer_fresh-eats'>
        <div>Fresh Eats</div>
        <div>Lorem ipusum ipusum Lorem ipusum ipusum Lorem ipusum ipusum Lorem ipusum ipusum Lorem ipusum ipusum Lorem ipusum ipusum
        Lorem ipusum 
        </div>
        <div className='footer__social'><div className='footer__social-icons'><a ><FaTwitter /></a></div><div className='footer__social-icons'><a><FaTiktok /></a></div><div className='footer__social-icons'><a><FaInstagram /></a></div></div>
    </div>
    <div className='footer_fresh-products'>
        <div className='footer_fresh-products__tittle'>Products</div>
    <div>
    <ul className='footer-list'>
        <li><a>Apple</a></li>
        <li><a>Orange</a></li>
        <li><a>Promaganate</a></li>
        <li><a>Water Melon</a></li>
        <li><a>More...</a></li>
    </ul>
    </div>
    </div>
    <div className='footer_ordernow'>
    <div className='footer_ordernow__tittle'>Order now</div>
    <div>
    <ul className='footer-list'>
        <li><a>Online</a></li>
        <li><a>Via SMS</a></li>
        <li><a>Call</a></li>
        <li><a>Social media</a></li>
        <li><a></a></li>
    </ul>
    </div>
    </div>
    <div className='footer_contacts'>
        <div className='footer_contacts__tittle'>Contact us</div>
        <div>
    <ul className='footer-list'>
        <li><a>21 Lorem Street, Lorem City</a></li>
        <li><a>+441 222 666 3456</a></li>
        <li><a>+441 738 984 2987</a></li>
        <li><a>fresheats@fresheats.com</a></li>
        
    </ul>
    </div>
    </div>
   
    </div>
    <div className='copyrights'>Copy rights Fresh Eats {dateBuilder(new Date())}</div>
    </div>
    </footer>
    </>
)
}

export default Footer;